<script setup lang="ts">
import { useSnackbarStore } from '@/store/snackbar'

interface IProps {
  modelValue?: boolean,
  changeRequestId?: number | string | null | undefined,
  changeRequestApprovalId?: number | string | null | undefined,
  changeRequestSubtaskId?: number | string | null | undefined,
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: false,
  changeRequestId: undefined,
  changeRequestApprovalId: undefined,
  changeRequestSubtaskId: undefined,
})

interface Emit {
  (e: 'update:modelValue', value: boolean): void
  (e: 'onClose'): void
  (e: 'onAddComment'): void
}

const emit = defineEmits<Emit>()

const route = useRoute()

const snackbarStore = useSnackbarStore()

const loading = ref<boolean>(false)

const hideDialog = () => {
  emit('update:modelValue', false)
  onClose()
}

const onClose = async () => {
  emit('onClose')
}

watch(() => props.modelValue, () => {
  // on show Dialog
  if (!!props.modelValue) {
  }
  // on hide Dialog
  else {
    onClose()
  }
})
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="800"
    :persistent="!!loading"
    @after-leave="onClose"
    @update:modelValue="emit('update:modelValue')"
  >
    <VBtn
      variant="elevated"
      density="compact"
      icon="tabler-x"
      :disabled="!!loading"
      class="v-dialog-close-btn"
      @click="hideDialog"
    />

    <ChangeRequestObjectCommentsBlock
      :change-request-id="changeRequestId"
      :change-request-approval-id="changeRequestApprovalId"
      :change-request-subtask-id="changeRequestSubtaskId"
      @onAddComment="emit('onAddComment')"
    />
  </VDialog>
</template>
